import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { emptyFragment } from '../../../../../EmptyFragment';
import { Ready } from '../../Types';
import Title from './Title';
import Upsell from './Upsell';

interface Props {
  state: Ready;
}

function Upsells({ state }: Props) {
  return fromArrayMaybe(state.resource.payload.upsells)
    .map((upsell) => (
      <div className="pt-10">
        <Title />
        <Upsell upsells={upsell} />
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Upsells);
